// Shipment.tsx
import { Block, Button, DataTable, DataTableRef, Tabs } from '@uni-space/uni-components';
import { useEffect, useRef, useState } from 'react';
import { ShipmentStatus } from '../model/shipment';
import { useShipmentSettingsTable } from '../model/useShipmentSettingsTable';
import { getAllShipments } from '../api';
import { useTranslation } from 'react-i18next';
import CreateShipmentModal from './CreateShipment';
import ShipmentScanningBag from './ShipmentScanningBag';
import { useShipmentStore } from '../model/useShipmentStore';

export default function Shipment() {
  const [shipmentStatus, setShipmentStatus] = useState<ShipmentStatus>(ShipmentStatus.Created);
  const [isMount, setIsMount] = useState<boolean>(false);
  const tableRef = useRef<DataTableRef>(null);

  const { t, i18n } = useTranslation();
  const { handleChangeCurrentShipment } = useShipmentStore();

  const handleRefetch = () => {
    tableRef.current?.refetchData();
  };

  const { columns, filters } = useShipmentSettingsTable({ onRefetch: handleRefetch, shipmentStatus });

  const [isOpenCreateModal, setIsOpenCreateModal] = useState<boolean>(false);

  const handleChangeTabs = (id: ShipmentStatus) => {
    setShipmentStatus(id);
  };

  const handleCloseModal = () => {
    setIsOpenCreateModal(false);
  };

  const handleCloseScanning = () => {
    // Рефрешим таблицу отгрузок при закрытии страницы пика только если за сессию был
    // хотя бы один успешный пик (добавление/удаление мешка) — чтобы "Assigned bags count"
    // подтянулся. Если ничего не сканировали — лишний запрос не делаем.
    const { hasSuccessfulPick, setHasSuccessfulPick } = useShipmentStore.getState();
    handleChangeCurrentShipment(null);
    if (hasSuccessfulPick) {
      handleRefetch();
    }
    setHasSuccessfulPick(false);
  };

  const handleOpenModal = () => {
    setIsOpenCreateModal(true);
  };

  useEffect(() => {
    if (isMount) tableRef.current?.refetchData();
    setIsMount(true);
  }, [shipmentStatus]);

  return (
    <>
      <Block sx={{ maxWidth: 700 }}>
        <Tabs
          value={shipmentStatus}
          onChange={(id) => handleChangeTabs(id as ShipmentStatus)}
          items={[
            { id: String(ShipmentStatus.Created), label: t('shipment.tabs.created') },
            { id: String(ShipmentStatus.Completed), label: t('shipment.tabs.completed') },
          ]}
        />
      </Block>

      <CreateShipmentModal
        isOpen={isOpenCreateModal}
        onClose={handleCloseModal}
        onRefetch={tableRef.current?.refetchData}
      />

      <ShipmentScanningBag shipmentStatus={shipmentStatus} onClose={handleCloseScanning} />

      <DataTable
        columns={columns}
        ref={tableRef}
        filters={filters}
        mobileWidth={678}
        renderControls={<Button onClick={handleOpenModal}>{t('shipment.controls.create')}</Button>}
        onFetch={(arg1, agr2, arg3, ctx) => getAllShipments(arg1, agr2, arg3, shipmentStatus, ctx)}
        lang={i18n.language}
        height="calc(100vh - 220px)"
      />
    </>
  );
}
